import { useEffect, useState } from 'react';

export function QR({ value, size = 200 }: { value: string; size?: number }) {
  const [svg, setSvg] = useState('');
  useEffect(() => {
    // The QR encoder loads only when a code is first shown.
    void import('qrcode').then(({ default: QRCode }) => QRCode.toString(value, { type: 'svg', margin: 1, errorCorrectionLevel: 'M', color: { dark: '#0e0a18', light: '#fff8ee' } })).then(setSvg);
  }, [value]);
  return (
    <div
      role="img"
      aria-label={`QR code for ${value}`}
      className="rounded-2xl overflow-hidden bg-paper p-2 shrink-0"
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
